import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Modal, Form } from "react-bootstrap";
import { toast } from "react-toastify";
import { getUser, updateCircularStatusApi } from "../../../../services/DocumentService";
import { StaticSelectInput } from "../../../constant/SelectInput";

const VersionStatus = ({ data, handleAfterUpdate }) => {
  const [showModal, setShowModal] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [remark, setRemark] = useState("");
  const [user, setUser] = useState("");
  const [userOptions, setUserOptions] = useState([]);
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);
  const { id } = useParams();

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const response = await getUser(); 
        setUserOptions(
          response.data.data.map((user) => ({
            value: user.id,
            label: `${user.first_name} ${user.last_name}`,
          }))
        );
      } catch (error) {
        toast.error("Error fetching user options");
        console.error("Error fetching users:", error);
      }
    };

    fetchUsers();
  }, []);

  useEffect(() => {
    if (showModal) {
      if (data?.status === "pending") {
        setSelectedStatus("approved");
      } 
    }
  }, [showModal, data?.status]);

  const handleModalOpen = () => setShowModal(true);

  const handleSelectChange = (name, value) => {
    setUser((prev) => ({ ...prev, [name]: value }));
  };

  const handleModalClose = () => {
    setShowModal(false);
    setSelectedStatus("");
    setRemark("");
    setUser("");
  };

  const handleStatusChange = (event) => setSelectedStatus(event.target.value);

  const handleRemarkChange = (event) => setRemark(event.target.value);
   
  const handleSubmit = async () => {
    console.log("clicked")
    try {
      setIsSubmitLoading(true);

      const payload = {
        id: data.id,
        status: selectedStatus,
        remarks: remark,
        tested_by: user.user, 
      };
      const response = await updateCircularStatusApi(data.id, payload);
      handleAfterUpdate(response.data.results);
      toast.success(response.data.message);
      handleModalClose();
    } catch (error) {
      toast.error(error.response?.data?.message);
    } finally {
      setIsSubmitLoading(false);
    }
  };

  return (
    <>
      {data?.status === "draft" ? (
        <span className="badge light border-0 badge-secondary badge-sm">Draft</span>
      ) : data?.status === "pending" ? (
        <span
          className="badge light border-0 badge-warning badge-sm cursor-pointer"
          onClick={handleModalOpen}
        >
          Pending
        </span>
      )  : data?.status === "rejected" ? (
        <span className="badge light border-0 badge-danger badge-sm">Rejected</span>
      ) : (
        <span
          className="badge light border-0 badge-success badge-sm"
        >
          Approved
        </span>
      )}

      <Modal show={showModal} centered onHide={handleModalClose}>
        <div className="modal-content">
          <div className="modal-body">
            <Form onSubmit={(e) => e.preventDefault()}>
              <Form.Group className="mb-3">
                <Form.Label>Select Status:</Form.Label>
                <div className="d-flex align-items-center">
                  {data?.status === "pending" && (
                    <Form.Check
                      type="radio"
                      id="approved"
                      label="Approve"
                      name="status"
                      value="approved"
                      checked={selectedStatus === "approved"}
                      onChange={handleStatusChange}
                    />
                  )}
                  <Form.Check
                    type="radio"
                    id="rejected"
                    label="Reject"
                    name="status"
                    className="ms-4"
                    value="rejected"
                    checked={selectedStatus === "rejected"}
                    onChange={handleStatusChange}
                  />
                </div>
              </Form.Group>

              {selectedStatus === "rejected" && (
                <Form.Group className="mb-3">
                  <Form.Label>Remark:</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    value={remark}
                    onChange={handleRemarkChange}
                    placeholder="Enter your remark here"
                  />
                </Form.Group>
              )}

              {selectedStatus === "approved" && (
                <Form.Group className="mb-3">
                  <StaticSelectInput
                    setParentInputValue={handleSelectChange}
                    optionsList={userOptions?.map((data) => ({
                      value: data.value,
                      label: data.label,
                    }))}
                    name="user"
                    id="user"
                    isClearable
                    placeholder="Select User"
                    label="Test By"
                    isRequired={true}
                  />
                </Form.Group>
              )}

              <div className="d-flex align-items-center justify-content-end">
                <button
                  type="button"
                  className="btn btn-primary me-3"
                  disabled={isSubmitLoading}
                  onClick={handleSubmit}
                >
                  {isSubmitLoading ? "Updating..." : "Update"}
                </button>
              </div>
            </Form>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default VersionStatus;